import adminAxios from "@/shared/api/adminAxiosInstance";

export const getDayScheduleData = (day) => {
    return adminAxios.get(`/admin/game-card-schedules`, {
        params: {
            time: day,
            isEnding: true
        }
    })
}
